import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';

export { GPX_EVENT_TYPES } from '@rsos/gainsight';

export const KEYWORD_NOTIFICATION_EVENTS = Object.freeze({
  KEYWORD_BANNER_CLICKED: 'keyword_banner_clicked',
});

export const trackKeywordNotificationEvent = ({
  event,
  type,
  data,
}: {
  event: string;
  type: (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
  data: Record<string, unknown>;
}) => {
  gspx.trackEvent({
    name: event,
    type: type,
    feature: GPX_FEATURES.KEYWORD_DETECTION,
    capability: GPX_CAPABILITIES.COMMUNICATOR_SUMMARIZATION_AND_KEYWORDS,
    route: GPX_ROUTES.COMMUNICATOR,
    entities: data,
  });
};

export const trackKeywordBannerClicked = (
  keywordSetName: string,
  keywordSetId: string,
) => {
  trackKeywordNotificationEvent({
    event: KEYWORD_NOTIFICATION_EVENTS.KEYWORD_BANNER_CLICKED,
    type: GPX_EVENT_TYPES.CLICK,
    data: {
      keyword_set_id: keywordSetId,
      keyword_set_name: keywordSetName,
    },
  });
};
